const { __ } = wp.i18n;
const { PanelBody, PanelRow, FormToggle } = wp.components;

const BControls = ({ setPreset, preset }) => {
  // const { preset = {}, presets = [] } = attributes;
  const { controls = [] } = preset?.preset?.options || [];

  const allControls = ["Large Play Button", "Restart", "Rewind", "Play", "Fast Forward", "Progress", "Current Time", "Duration", "Mute", "Volume", "PIP", "Airplay", "Settings", "Download", "Fullscreen"];

  const controlsSchema = ["play-large", "restart", "rewind", "play", "fast-forward", "progress", "current-time", "duration", "mute", "volume", "pip", "airplay", "settings", "download", "fullscreen"];

  const handleControl = (control) => {
    let newControls = [...controls];
    if (controls.includes(control)) {
      newControls.splice(newControls.indexOf(control), 1);
    } else {
      newControls = [...controls, control];
    }
    const tempControls = [...controlsSchema];
    controlsSchema.map((item) => {
      if (!newControls.includes(item)) {
        tempControls.splice(tempControls.indexOf(item), 1);
      }
    });

    setPreset({ options: { ...preset?.preset?.options, controls: tempControls } });
  };

  return (
    <PanelBody title={__("Controls", "ytp")} initialOpen={false}>
      {allControls.map((control, index) => {
        const key = controlsSchema[index];
        return (
          <PanelRow key={control}>
            <label htmlFor={control} className="label">
              {control}
            </label>
            <FormToggle id={key} checked={controls.includes(key) || false} onChange={() => handleControl(key)} />
          </PanelRow>
        );
      })}
    </PanelBody>
  );
};

export default BControls;
